import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useCentroMonitoreo } from '../../../../hooks/monitoreo/useCentroMonitoreo'
import sinImagen from '../../../../assets/images/sinImagen.jpg'
import { utilLeaflet } from '../../../../utils/utilLeaflet';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';

const ContenedorIncidenciasInspectoria = ({codEmpresa = 0}) => {
  const leafletClass = useMemo(() => new utilLeaflet(), []);
  
  const [latitudDefault, longitudDefault] = [-11.989584, -77.066672]
  const mapRef = useRef()
  const [urlImagen,setUrlImagen] = useState()
  const refIntervalo = useRef()
  const hookCentroMonitoreo = useCentroMonitoreo()

  // delete L.Icon.Default.prototype._getIconUrl;
  // L.Icon.Default.mergeOptions({
  //   iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  //   iconUrl: require('leaflet/dist/images/marker-icon.png'),
  //   shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  // });

  useEffect(() => {
    (async () => {
      await hookCentroMonitoreo.listarUltimasIncidencias(codEmpresa)
      refIntervalo.current = setInterval(async () => {
        await hookCentroMonitoreo.listarUltimasIncidencias(codEmpresa)
      }, 10000);
      leafletClass.inicializarMapa({
        mapDiv: mapRef.current,
      });
    })();
    return(() => {
      clearInterval(refIntervalo.current)
    })
  },[])

  useEffect(() => {
    setUrlImagen(
      hookCentroMonitoreo.ultimaIncidencia.imagen
      ? `https://minio.api.abexacloud.com/api/Archivo/verImagen?NombreCarpeta=photos-incidents-instra&NombreImagen=${(hookCentroMonitoreo.ultimaIncidencia.imagen)?.split('*')[0]}`
      : sinImagen
    );
    if(Object.keys(hookCentroMonitoreo.ultimaIncidencia).length != 0){
      leafletClass.eliminarTodosLosMarcadores()
      leafletClass.crearMarcador({
        lat: Number(hookCentroMonitoreo.ultimaIncidencia?.latitudIncidencia || 0),
        lng: Number(hookCentroMonitoreo.ultimaIncidencia?.longitudIncidencia || 0),
        centrar: true
      })
    }
  },[hookCentroMonitoreo.ultimaIncidencia])

  return (
    <div className='flex flex-col h-full shadow-xl shadow-white overflow-hidden'>
      <div className='bg-[#017eff] font-bold flex items-center justify-center h-[50px]'>INSPECTORIA</div>
      <div className='flex items-center justify-center h-full'>
        <div className='flex flex-col gap-3 items-center w-full px-4'>
          <span className='font-bold text-xl'>Información de campo</span>
          <div className='relative border rounded-tr-md rounded-bl-md w-full flex-grow p-2 gap-3 flex flex-col shadow-md shadow-white'>
            <div className='h-[200px] border border-[#777777] rounded-md flex items-center justify-center'>
              <img className="h-full" src={urlImagen} alt="" />
            </div>
            <div className='h-[200px]'>
              <div className='grid grid-cols-[auto_auto_1fr] gap-x-2 gap-y-2 py-2 text-sm '>
                <span className="font-bold">EMPRESA</span>
                <span>:</span>
                <span className='overflow-hidden whitespace-nowrap text-ellipsis' title={hookCentroMonitoreo.ultimaIncidencia.nomEmpresa}>{hookCentroMonitoreo.ultimaIncidencia.nomEmpresa}</span>
                <span className="font-bold">UBICACIÓN</span>
                <span>:</span>
                <span className='overflow-hidden whitespace-nowrap text-ellipsis' title={hookCentroMonitoreo.ultimaIncidencia.nomControl}>{hookCentroMonitoreo.ultimaIncidencia.nomControl}</span>
                <span className="font-bold">RUTA</span>
                <span>:</span>
                <span className='overflow-hidden whitespace-nowrap text-ellipsis'>{hookCentroMonitoreo.ultimaIncidencia.nomRuta}</span>
                <span className="font-bold">PADRÓN</span>
                <span>:</span>
                <span className='overflow-hidden whitespace-nowrap text-ellipsis'>{hookCentroMonitoreo.ultimaIncidencia.padronUnidad}</span>
                <span className="font-bold">F.REGISTRO</span>
                <span>:</span>
                <span className='overflow-hidden whitespace-nowrap text-ellipsis' title={hookCentroMonitoreo.ultimaIncidencia.fechaHoraRegistro}>{hookCentroMonitoreo.ultimaIncidencia.fechaHoraRegistro}</span>
              </div>
              <div className='text-sm text-justify flex flex-col text-ellipsis overflow-hidden' title={hookCentroMonitoreo.ultimaIncidencia.observacion || 'Sin observaciones'}>
                <span className='font-bold'>OBSERVACIÓN</span>
                {hookCentroMonitoreo.ultimaIncidencia.observacion || 'Sin observaciones'}
              </div>
            </div>
            <div ref={mapRef} className='border border-[#777777] h-[200px]' aria-disabled={true}></div>
            {
              Object.keys(hookCentroMonitoreo.ultimaIncidencia).length != 0
              ? <></>
              : <div className='absolute w-full h-full bg-blue-500 z-[100000] top-0 left-0 opacity-30 flex items-center justify-center'>
                  <span className='text-xl text-center'>No hay información<br></br>para mostrar</span>
                </div>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContenedorIncidenciasInspectoria